module.exports = __webpack_public_path__ + "static/img/gaozhonglishi14.d12c1202.jpg";